import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const GraciasPorTuCompra = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const queryString = window.location.search;
    window.location.replace("/gracias" + queryString);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500 mx-auto mb-4"></div>
        <p className="text-gray-400">{t("graciasRedirect.redirecting")}</p>
      </div>
    </div>
  );
};

export default GraciasPorTuCompra;
